import TextField from '@mui/material/TextField';

import { Field } from '@/components/ui/Field';

import { State } from '../State';

export function FieldExamples() {
  return (
    <>
      <State title="Plain">
        <Field label="Campaign name" testId="gallery-field-plain">
          <TextField defaultValue="Clean Rivers Pledge" />
        </Field>
      </State>

      <State title="With a hint">
        <Field
          label="Website"
          hint="Shown on the organization's page in the app."
          testId="gallery-field-with-hint"
        >
          <TextField placeholder="https://example.org" />
        </Field>
      </State>

      <State
        title="With an error"
        note="Announced to a screen reader and tied to the box with aria-describedby."
      >
        <Field
          label="Contact email address"
          error="Enter a valid email address"
          testId="gallery-field-with-error"
        >
          <TextField defaultValue="not-an-address" />
        </Field>
      </State>
    </>
  );
}
